import { Component, OnInit,ViewEncapsulation } from '@angular/core';
import './loginlayout.component.css';
@Component({
  selector: 'app-loginlayout',
  templateUrl: './loginlayout.component.html',
  //styleUrls: ['./loginlayout.component.css']
  encapsulation: ViewEncapsulation.None
})
export class LoginlayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
